import React, { useState } from "react";
import { Button, Modal } from "antd";
import {
  DmtAndPayout2Together,
  DmtAndPayoutTogether,
} from "../../../ApiServices/Apifun";
import useOtpHook from "../../../Hooks/useOtpHook";
import { dispatchtoast } from "../../../Utils";

const OtpDmt2 = ({
  isOpen,
  setIsOpen,
  setHide,
  setResponse,
  setpaymodal,
  setShowSuccess,
  setCombinedAmount,
  otherFields,
  endpoint,
}) => {
  const [btnLoading, setBtnLoading] = useState(false);
  const { handleChange, handleKeyUp, pin, inputRefs } = useOtpHook(4);

  const handleVerify = () => {
    setBtnLoading(true);
    const formdata = new FormData();
    formdata.append("otp", pin.join(""));
    Object.keys(otherFields).map((key) =>
      formdata.append(key, otherFields[key])
    );
    DmtAndPayout2Together(formdata, "", endpoint)
      .then((res) => {
        if (res) {
          if (res.status) {
            const result = res.data.reduce(
              (accumulator, transaction) => {
                const status = transaction.status;
                if (status === "SUCCESS") {
                  accumulator.success += transaction.amount;
                } else if (status === "PENDING") {
                  accumulator.pending += transaction.amount;
                } else if (status === "FAILED") {
                  accumulator.failed += transaction.amount;
                }
                return accumulator;
              },
              { success: 0, pending: 0, failed: 0 }
            );
            setResponse(res);
            setCombinedAmount(result);
            setHide(false);
            setShowSuccess(true);
            setIsOpen(false);
          }
        } else {
          dispatchtoast("Something went wrong", true);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };

  return (
    <Modal
      title={"Verify OTP"}
      footer={null}
      className="shadow-normal"
      width={300}
      maskClosable={false}
      open={isOpen}
      onCancel={() => {
        setIsOpen(false);
        setpaymodal(false);
      }}
    >
      <div className="  rounded-3xl shadow-normal bg-white p-5">
        <div className="header flex flex-col justify-center items-center">
          <p className="text-[15px] mt-3 text-gray-500">Enter OTP</p>
        </div>
        <div className=" mt-5 flex justify-center items-center">
          {[1, 2, 3, 4].map((i, index) => {
            return (
              <>
                <input
                  key={index}
                  ref={inputRefs[index]}
                  type="text"
                  maxLength={1}
                  className="w-[15px] otpinput xs:w-[35px] sm:w-[35px] md:w-[40px] text-bsblackrgb rounded-md bg-gray-300 h-8  mx-1 border-none focus:outline-none focus:border-none text-center"
                  value={pin[index]}
                  onChange={(e) => handleChange(index, e.target.value)}
                  onKeyUp={(e) => handleKeyUp(index, e)}
                />
              </>
            );
          })}
        </div>
        <Button
          loading={btnLoading}
          onClick={() => pin.length === 4 && handleVerify()}
          className={`SignInBtn w-full ${
            pin.length === 4 ? "cursor-pointer" : "cursor-not-allowed"
          }  mt-4 ${
            pin.length === 4 ? "bg-primary" : "bg-bsgray"
          }  flex justify-center border-none items-center h-12 mt-10 rounded-full text-white text-[12px] font-bold`}
        >
          <p>Verify OTP</p>
        </Button>
      </div>
    </Modal>
  );
};

export default OtpDmt2;
